import { render } from "./MarketeersAccountsWidget.vue?vue&type=template&id=a2f07042&scoped=true&ts=true"
import script from "./MarketeersAccountsWidget.vue?vue&type=script&lang=ts"
export * from "./MarketeersAccountsWidget.vue?vue&type=script&lang=ts"

import "./MarketeersAccountsWidget.vue?vue&type=style&index=0&id=a2f07042&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f07042"]])

export default __exports__